import { useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { Button } from '~/shared/ui'
import { useUploadQueueStore } from '../model/use-upload-queue-store'
import { UploadModal } from './upload-modal/upload-modal'

export function UploadDocumentsButton(): React.ReactElement | null {
  const isEnabled = useIsFeatureEnabled('2026-05-documents-uploading')
  const openModal = useUploadQueueStore((s) => s.openModal)

  if (!isEnabled) return null

  return (
    <>
      <Button
        size="small"
        tonal
        onClick={openModal}
        materialIcon="upload"
      >
        Upload
      </Button>
      <UploadModal />
    </>
  )
}
